import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AuthConsumer } from '../context/AuthContext';
import { toast } from './Notifier';

class Login extends Component {
	state = {
		user_login: '',
		user_pass: '',
		loginError: '',
		requestPending: false,
	};

	handleChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	handleLogin = (e, login) => {
		e.preventDefault();

		this.setState({ requestPending: true, loginError: '' });

		const { user_login, user_pass } = this.state;
		if (user_login === '' || user_pass === '') {
			this.setState({
				requestPending: false,
			});
			toast('Email or Password cannot be empty', {
				status: 'error',
				timeout: 2000,
			});
			return;
		}
		return login({ user_login, user_pass }).then((res) => {
			if (res) {
				const { message } = res;
				this.setState({ requestPending: false });
				if (message) {
					toast(message, { status: 'error', timeout: 2000 });
				}
			}
		});
	};

	render() {
		return (
			<AuthConsumer>
				{({ login }) => (
					<div className="container-fluid">
						<div className="row justify-content-center">
							{/* main content area */}
							<main className="login-box col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-9 col-xl-9">
								<h1 className="text-center mt-5 pt-3">
									<Link to="#">
										<img
											src={require('../assets/logo_school.png')}
											width="auto"
											height={150}
											alt="Logo"
										/>
									</Link>
								</h1>
								{/* card for login box */}
								<div className="row no-gutters">
									<div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 order-2 order-sm-2 order-md-2 order-lg-1 order-xl-1 p-0">
										<div className="card">
											<div className="login-form login-instructions">
												<div className="login-title text-left">
													Portal Instructions
												</div>
												<div className="scrollable">
													<p>
														Hello! This is a new School Information System for
														you. It is user friendly. The platform ensures a
														seamless interaction. You can register for the
														session, manage your documents, register your
														courses, and access your course materials with more
														flexibilities than before. Provide your
														matriculation number/email and password to access
														your account. Your Password is your last name, in
														lowercase (e.g. "Aremu" being your last name, your
														password would be "aremu"). All admitted students
														can login with their application number pending the
														time they are issued matriculation numbers.
													</p>
													<p className="font-weight-bold">
														{/* Need help? <br />
														Use the live chat or SMS/Call 0807 759 3559, 0807
														759 3552 or Email ssu@dlc.ui.edu.ng */}
													</p>
												</div>
											</div>
										</div>
									</div>
									<div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 order-1 order-sm-1 order-md-1 order-lg-2 order-xl-2">
										<div className="card">
											<div className="card-body p-0 border-left">
												<form autoComplete="off">
													<div className="login-form">
														<div className="login-title text-center">
															Sign In to Portal
														</div>
														<div className="login-container">
															<div className="form-group mb-35">
																<label htmlFor="userlogin">
																	Matric. Number / Email address
																</label>
																<input
																	type="email"
																	className="form-control"
																	id="userlogin"
																	name="user_login"
																	aria-describedby="emailHelp"
																	placeholder="Enter matric. number / email"
																	onChange={this.handleChange}
																/>
																{/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
															</div>
															<div className="form-group">
																<label htmlFor="userpassword">Password</label>
																<input
																	type="password"
																	className="form-control"
																	id="userpassword"
																	name="user_pass"
																	placeholder="Password"
																	onChange={this.handleChange}
																/>
															</div>
															<div className="forgot-password">
																<Link to="/forgotpassword">
																	Forgot Password?
																</Link>
															</div>
														</div>
													</div>
													{/* button */}
													<div className="footer">
														{/* subtitute active class for disabled to either make button active or inactive */}

														<button
															className="position-relative btn w-100 btn-primary-big btn-border-radius-login active"
															onClick={(e) => this.handleLogin(e, login)}
															disabled={
																this.state.requestPending ? true : false
															}
															style={{
																backgroundColor: this.state.requestPending
																	? '#02750e'
																	: '#00d715',
															}}
														>
															{this.state.requestPending ? (
																<i className="fas fa-circle-notch fa-spin" />
															) : (
																' Sign In'
															)}
														</button>
													</div>
												</form>
											</div>
										</div>
									</div>
								</div>
								{/* end card for login box  */}
							</main>
							{/* main content area */}
						</div>
					</div>
				)}
			</AuthConsumer>
		);
	}
}

export default Login;
